import { Archive, ChatIcon, OcsDeviceIcon, ScheduleIcon } from '@icons';
import { MdOutlineLibraryAddCheck, MdRepeat } from 'react-icons/md';
import {
  ArchiveCasesPermissions,
  BulkAssignmentPermissions,
  CaseBoardPermissions,
  ChatViewPermissions,
  MultiCaseSuggestPermissions,
  SchedulerPermissions,
} from '@/permissions';

export const LP_MAIN_MENU = [
  {
    to: '/',
    permissions: [CaseBoardPermissions.CaseBoardRead],
    label: (
      <>
        <OcsDeviceIcon />
        <span className="text-xs-m">Cases</span>
      </>
    ),
  },
  {
    to: '/chats',
    permissions: [ChatViewPermissions.ViewChat],
    label: (
      <>
        <ChatIcon />
        <span className="text-xs-m">Chats</span>
      </>
    ),
  },
  {
    key: 'schedule',
    permissions: [SchedulerPermissions.ScheduleRead],
    label: (
      <>
        <ScheduleIcon />
        <span className="text-xs-m">Schedule</span>
      </>
    ),
    children: [
      { label: 'Specialists', to: '/schedule/cs', permissions: [SchedulerPermissions.CSSchedulesRead] },
      { label: 'Surgeons Liver', to: '/schedule/s-li', permissions: [SchedulerPermissions.SSchedulesRead] },
      { label: 'Surgeons Lungs & Heart', to: '/schedule/s-htlu', permissions: [SchedulerPermissions.SSchedulesRead] },
      { label: 'Coordinators', to: '/schedule/cc', permissions: [SchedulerPermissions.CCSchedulesRead] },
      { label: 'OMS', to: '/schedule/oms', permissions: [SchedulerPermissions.OMSSchedulesRead] },
    ],
  },
  {
    to: '/archive',
    permissions: [ArchiveCasesPermissions.ViewArchive],
    label: (
      <>
        <Archive />
        <span className="text-xs-m">Archive</span>
      </>
    ),
  },
  {
    to: '/bulk-assignment',
    permissions: [BulkAssignmentPermissions.ViewBulkAssignment],
    label: (
      <>
        <MdOutlineLibraryAddCheck size={32} />
        <span className="text-xs-m">Bulk</span>
      </>
    ),
  },
  {
    to: '/multi-case-suggest',
    permissions: [MultiCaseSuggestPermissions.ReadMCS],
    label: (
      <>
        <MdRepeat size={32} />
        <span className="text-xs-m text-center">Multi-Case Suggestion</span>
      </>
    ),
  },
];
